const KEY = 'ps24_pro_budgets_v1';

export function listBudgets() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

export function saveBudget(budget) {
  const list = listBudgets();
  const idx = list.findIndex(b => b.id === budget.id);
  if (idx >= 0) list[idx] = budget;
  else list.unshift(budget);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 50)));
  return budget;
}

export function deleteBudget(id) {
  const list = listBudgets().filter(b => b.id !== id);
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function getBudget(id) {
  return listBudgets().find(b => b.id === id) || null;
}

export function newId() {
  return 'b_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}
